
import wixWindow from 'wix-window';
$w.onReady(function () {

});


export function container1_mouseIn(event, $w) {
	if(wixWindow.formFactor == 'Desktop')
	$w("#imageOnHover").show();
}

export function container1_mouseOut(event, $w) {
	if(wixWindow.formFactor == 'Desktop')
	$w("#imageOnHover").hide();
}

export function container2_mouseIn(event, $w) {
	if(wixWindow.formFactor == 'Desktop')
	$w("#signTempHover").show();
}

export function container2_mouseOut(event, $w) {
	if(wixWindow.formFactor == 'Desktop')
	$w("#signTempHover").hide();
}